module.exports = __webpack_public_path__ + "img/karta.3c6b878.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/karta.png
// module id = cChx
// module chunks = 0